import React from 'react';
import { Skeleton } from '@heroui/react';
import { cn } from '@/utils/cn';

interface GuideCardSkeletonProps {
  className?: string;
}

const GuideCardSkeleton: React.FC<GuideCardSkeletonProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'bg-white dark:bg-gray-900 rounded-2xl overflow-hidden border border-gray-200/60 dark:border-gray-800/60 shadow-sm flex flex-col h-full',
        className,
      )}
    >
      {/* Header skeleton */}
      <div className="relative overflow-hidden bg-gray-100 dark:bg-gray-800">
        <div className="p-6 pb-8">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1 min-w-0 pr-2">
              <Skeleton className="mb-3 h-7 w-3/4 rounded-lg" />
              <Skeleton className="mb-2 h-4 w-full rounded-lg" />
              <Skeleton className="h-4 w-2/3 rounded-lg" />
            </div>
            <Skeleton className="w-12 h-12 rounded-xl flex-shrink-0" />
          </div>
          <div className="flex gap-2 mt-4">
            <Skeleton className="h-6 w-20 rounded-full" />
            <Skeleton className="h-6 w-24 rounded-full" />
          </div>
        </div>
      </div>

      {/* Content skeleton */}
      <div className="p-6 flex-1 flex flex-col bg-white dark:bg-gray-900">
        {/* Stats skeleton */}
        <div className="flex items-center gap-6 mb-5">
          <div className="flex items-center gap-2">
            <Skeleton className="w-7 h-7 rounded-lg" />
            <Skeleton className="h-4 w-16 rounded" />
          </div>
          <div className="flex items-center gap-2">
            <Skeleton className="w-7 h-7 rounded-lg" />
            <Skeleton className="h-4 w-20 rounded" />
          </div>
        </div>

        {/* Steps preview skeleton */}
        <div className="mb-6 flex-1">
          <Skeleton className="h-3 w-32 rounded mb-4" />
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <Skeleton className="w-7 h-7 rounded-lg flex-shrink-0" />
              <Skeleton className="h-4 flex-1 rounded" />
            </div>
            <div className="flex items-start gap-3">
              <Skeleton className="w-7 h-7 rounded-lg flex-shrink-0" />
              <Skeleton className="h-4 flex-1 rounded" />
            </div>
            <div className="flex items-start gap-3">
              <Skeleton className="w-7 h-7 rounded-lg flex-shrink-0" />
              <Skeleton className="h-4 flex-1 w-2/3 rounded" />
            </div>
          </div>
        </div>

        {/* Button skeleton */}
        <Skeleton className="w-full h-12 rounded-xl mt-auto" />
      </div>
    </div>
  );
};

export default GuideCardSkeleton;
